/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecoveringStock } from '../../models/recovering-stock';
import { UpdateRecoveringStockDto } from '../../models/update-recovering-stock-dto';

export interface UpdateOneBaseMgmtRecoveringStockControllerRecoveringStock$Params {
  id: number;
      body: UpdateRecoveringStockDto
}

export function updateOneBaseMgmtRecoveringStockControllerRecoveringStock(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringStock>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtRecoveringStockControllerRecoveringStock.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecoveringStock>;
    })
  );
}

updateOneBaseMgmtRecoveringStockControllerRecoveringStock.PATH = '/api/mgmt/recovering-stock/{id}';
